import { defineStore } from 'pinia'

export const useAlertStore = defineStore({
  id: 'alert',
  state: () => ({
    alert: [],
    //alert: null
  }),
  actions: {
    success(message) {
      this.push(message, 'success');
    },
    error(message) {
      // Ignore Apollo store-reset internal query cancellations during logout/navigation
      if (typeof message === 'string' && (message.includes('Store reset') || message.includes('store was reset'))) {
        return;
      }
      this.push(message, 'danger');
    },
    // Shared by success()/error() -- skips the push if an alert with the same
    // type+message is already showing, so a tight retry/error loop (a failed
    // request firing repeatedly) can't flood the screen with duplicates of
    // the same message.
    push(message, type) {
      const alreadyShowing = this.alert.some((a) => a.type === type && a.message === message);
      if (alreadyShowing) return;

      const id = `${Math.random().toString(36).substr(2, 9)}-${Date.now()}`;
      this.alert.push({ message, type, id });
      this.remove(id);
    },
    remove(id) {
      setTimeout(() => {
        this.alert = this.alert.filter(msg => msg.id !== id);
      }, 5000);
    },
    clear() {
      this.alert = [];
      //this.alert = null;
    },
  }
})
